import React from 'react';

import { useFieldBulletinBoardEdit } from '../../services/fieldBulletinBoard/FieldBulletinBoardEditContext';

import { FieldBulletinBoardDeleteButton } from './FieldBulletinBoardDeleteButton';
import { FieldBulletinBoardHeader } from './FieldBulletinBoardHeader';
import { FieldBulletinBoardPublicationStatusChip } from './FieldBulletinBoardPublicationStatusChip';

import { messageUtility } from '../../utilities/messageUtility';

/**
 * 現場掲示板編集 ヘッダー
 * @returns { JSX.Element }
 */
export function FieldBulletinBoardHeaderEdit() {
  const {
    closeConfirmDialog,
    executeBack,
    getData,
    getModalDisplayInfo,
    handleBack,
  } = useFieldBulletinBoardEdit();

  const data = getData();

  return (
    <FieldBulletinBoardHeader
      handleBack={handleBack}
      masterHeadertitle={messageUtility.getMessage('I-000-167-04')}
      breadcrumbsName={messageUtility.getMessage('I-000-166-01')}
      closeConfirmDialog={closeConfirmDialog}
      getModalDisplayInfo={getModalDisplayInfo}
      executeBack={executeBack}
      button={<FieldBulletinBoardDeleteButton />}
      status={
        <FieldBulletinBoardPublicationStatusChip
          bulletinBoardPublicationStatusId={
            data.bulletin_board_publication_status
          }
        />
      }
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardHeaderEdit.jsx